<script setup lang="ts">
const { t } = useI18n()

useHead({
  titleTemplate: () => `${t('terms.title')} | SMSBAT`,
  meta: [
    { name: "description", content: () => t('terms.title') },
    { property: "og:title", content: () => `${t('terms.title')} | SMSBAT` },
    { property: "og:description", content: () => t('terms.title') },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary_large_image" }
  ]
})
</script>

<template>
  <div class="m-5 terms flex flex-col gap-4">
    <h1 class="terms__title text-2xl font-bold">{{ $t('terms.title') }}</h1>
    <div class="terms__block flex gap-2">
      <span>1.</span>
      <p>
        {{ $t('terms.blocks[0][0]') }}
        <NuxtLink to="https://smsbat.com/" class="text-blue-600 hover:text-purple-600 underline" external
          target="_blank">https://smsbat.com/</NuxtLink>
        {{ $t('terms.blocks[0][1]') }}
      </p>
    </div>

    <div class="terms__block flex gap-2">
      <span>2.</span>
      <p>
        {{ $t('terms.blocks[1][0]') }}
        <NuxtLink to="https://smsbat.com/" class="text-blue-600 hover:text-purple-600 underline" external
          target="_blank">https://smsbat.com/</NuxtLink>
        , <NuxtLink to="https://omni.smsbat.com/" class="text-blue-600 hover:text-purple-600 underline" external
          target="_blank">https://omni.smsbat.com/</NuxtLink>
        , <NuxtLink to="https://counterbat.com/" class="text-blue-600 hover:text-purple-600 underline" external
          target="_blank">https://counterbat.com/</NuxtLink>
        {{ $t('terms.blocks[1][1]') }}
        <NuxtLink to="https://indexbat.com/" class="text-blue-600 hover:text-purple-600 underline" external
          target="_blank">https://indexbat.com/</NuxtLink>
        {{ $t('terms.blocks[1][2]') }}
      </p>
    </div>

    <div class="terms__block flex gap-2">
      <span>3.</span>
      <div>
        {{ $t('terms.blocks[2][0]') }}
        <ul class="pl-4">
          <li>1. {{ $t('terms.blocks[2][1][0]') }}</li>
          <li>2. {{ $t('terms.blocks[2][1][1]') }}</li>
          <li>3. {{ $t('terms.blocks[2][1][2]') }}</li>
          <li>4. {{ $t('terms.blocks[2][1][3]') }}</li>

        </ul>
      </div>
    </div>

    <div class="terms__block flex gap-2">
      <span>4.</span>
      <p>
        {{ $t('terms.blocks[3][0]') }}
        <NuxtLink to="https://smsbat.com/" class="text-blue-600 hover:text-purple-600 underline" external
          target="_blank">https://smsbat.com/</NuxtLink>
        {{ $t('terms.blocks[3][1]') }}
      </p>
    </div>

    <div class="terms__block flex gap-2">
      <span>5.</span>
      <p>
        {{ $t('terms.blocks[4][0]') }}
        <NuxtLink to="https://smsbat.com/" class="text-blue-600 hover:text-purple-600 underline" external
          target="_blank">https://smsbat.com/</NuxtLink>
      </p>
    </div>

    <div class="terms__block flex gap-2">
      <span>6.</span>
      <p>
        {{ $t('terms.blocks[5][0]') }}
        <NuxtLink to="https://smsbat.com/" class="text-blue-600 hover:text-purple-600 underline" external
          target="_blank">https://smsbat.com/</NuxtLink>
        {{ $t('terms.blocks[5][1]') }}
      </p>
    </div>

    <div class="terms__block flex gap-2">
      <span>7.</span>
      <div>
        {{ $t('terms.blocks[6][0][0]') }} support@smsbat.com. {{ $t('terms.blocks[6][0][1]') }}
        <NuxtLink to="https://smsbat.com/" class="text-blue-600 hover:text-purple-600 underline" external
          target="_blank">https://smsbat.com/</NuxtLink>
        <ul class="pl-4">
          <li>1. {{ $t('terms.blocks[6][1][0]') }}</li>
          <li>2. {{ $t('terms.blocks[6][1][1][0]') }}
            <NuxtLink to="https://smsbat.com/" class="text-blue-600 hover:text-purple-600 underline" external
              target="_blank">https://smsbat.com/
            </NuxtLink>
            {{ $t('terms.blocks[6][1][1][1]') }}
          </li>
        </ul>
      </div>
    </div>

    <div class="terms__block flex gap-2">
      <span>8.</span>
      <p>
        {{ $t('terms.blocks[7][0]') }}
      </p>
    </div>

    <div class="terms__block flex gap-2">
      <span>9.</span>
      <p>
        {{ $t('terms.blocks[8][0]') }}
        <NuxtLink to="https://smsbat.com/" class="text-blue-600 hover:text-purple-600 underline" external
          target="_blank">https://smsbat.com/. </NuxtLink>
        {{ $t('terms.blocks[8][1]') }}
      </p>
    </div>

    <div class="terms__block flex gap-2">
      <span>10.</span>
      <p>
        {{ $t('terms.blocks[9][0]') }}
      </p>
    </div>

    <div class="terms__block flex gap-2">
      <span>11.</span>
      <p>
        {{ $t('terms.blocks[10][0]') }}
      </p>
    </div>
  </div>
</template>

